import React from "react";
import styled from "styled-components";

import { getCarbonOffset } from "../../../Functions/functions";

const Menu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  font-weight: 600;
  color: ${(props) => props.theme.palette.yellow.light};
  background-color: ${(props) => props.theme.palette.primary.main};

  border-radius: ${(props) => props.theme.border.radius};
  box-shadow: ${(props) =>
    props.theme.border.shadow + props.theme.palette.primary.main};

  padding: 1vh 2vh;
  margin: 1vh 0;
`;
const OutputPanel = (props) => {
  return (
    <Menu>
      <div>
        <h3>Carbon Offset</h3>
        <h4>
          {Math.round(getCarbonOffset(props.payment)).toLocaleString()} tonnes
        </h4>
      </div>
    </Menu>
  );
};
export default OutputPanel;
